import Link from "next/link";
import style from "src/styles/terms/Terms.module.scss";
import Banner from "@/components/common/Banner/Banner";
import { FREE_TRIAL_DAYS } from "@/constant";
import Layout from "@/components/layout/Layout";
import SeoHeader from "@/components/common/Seo/SeoHeader";
import cn from "classnames";
const Terms = () => {
  return <Layout nav footer data-sentry-element="Layout" data-sentry-component="Terms" data-sentry-source-file="index.tsx">
      <SeoHeader seoTitle="QR Code Creator - Terms and Conditions" data-sentry-element="SeoHeader" data-sentry-source-file="index.tsx" />
      <div>
        <Banner title="Terms & Conditions" type="terms" data-sentry-element="Banner" data-sentry-source-file="index.tsx" />
        <div className={style.container}>
          <div className={style.box}>
            <h3 className={style.title}>Preamble</h3>
            <p className={style.text}>
              This website (www.qrcodecreator.com) (the “Site”) is operated by Convertizing LTD, a
              company registered at 407 Cubes 1, Beacon South Quarter, Republic of Ireland. The Site
              develops, operates, and provides a variety of services in the areas among which are
              the creation, design, management, optimization, scanning, and analysis of QR Codes,
              vCards, (mobile) websites, and the relevant tools and advisory services (“Services”)
              for its customers (hereinafter referred to as "User" or "Users"). We offer these
              services at &nbsp;
              <Link href={"/"} className={cn(style.innerLink, style.pageLinkX)} data-sentry-element="Link" data-sentry-source-file="index.tsx">
                www.qrcodecreator.com
              </Link>

              . Throughout the Site and these General Terms and Conditions, the terms “we”, “us” and
              “our” refer to Convertizing LTD.
              <br />
              <br />
              We reserve the right to add additional domains in the foreseeable future. With these
              General Terms and Conditions ("T&C" or “Agreement”), we aim to establish a transparent
              business relationship with the User, while also protecting itself from any malicious
              use. By accepting the T&C, you also consent to our Privacy Policy in the version in
              effect at the time the Agreement was executed available here:
              <br />
              <Link href={"/policy"} className={cn(style.innerLink, style.pageLink)} data-sentry-element="Link" data-sentry-source-file="index.tsx">
                qrcodecreator.com/policy
              </Link>

              <br />
              The T&C comes into effect on: 25.07.2024
            </p>
            <h3 className={style.title}>Table of Contents</h3>
            <a className={style.subtitle_link} href="#scope-of-this-agreement">
              1. Scope of this Agreement
            </a>
            <br />
            <a className={style.subtitle_link} href="#conclusion-of-the-agreement">
              2. Conclusion of the Agreement
            </a>
            <br />
            <a className={style.subtitle_link} href="#services">
              3. Services
            </a>
            <br />
            <a className={style.subtitle_link} href="#age-requirement">
              4. Age Requirement
            </a>
            <br />
            <a className={style.subtitle_link} href="#remuneration">
              5. Remuneration
            </a>
            <br />
            <a className={style.subtitle_link} href="#user-rights-and-obligations">
              6. User Rights and Obligations
            </a>
            <br />
            <a className={style.subtitle_link} href="#license-to-qrcodecreator">
              7. License to QR Code Creator
            </a>
            <br />
            <a className={style.subtitle_link} href="#revocation">
              8. Revocation
            </a>
            <br />
            <a className={style.subtitle_link} href="#liability">
              9. Liability
            </a>
            <br />
            <a className={style.subtitle_link} href="#indemnity">
              10. Indemnity
            </a>
            <br />
            <a className={style.subtitle_link} href="#non-disclosure">
              11. Non-disclosure
            </a>
            <br />
            <a className={style.subtitle_link} href="#intellectual-property-rights">
              12. Intellectual Property Rights
            </a>
            <br />
            <a className={style.subtitle_link} href="#termination-duration">
              13. Termination/Duration
            </a>
            <br />
            <a className={style.subtitle_link} href="#obligatory-arbitration-provisions">
              14. Obligatory Arbitration Provisions (applies only to US citizens)
            </a>
            <br />
            <a className={style.subtitle_link} href="#final-regulations">
              15. Final Regulations
            </a>
            <br />
            <a className={style.subtitle_link} href="#acceptable-use-guidelines">
              16. Acceptable Use Guidelines
            </a>
            <br />
            <a className={style.subtitle_link} href="#upload-content-license">
              17. Upload Content License
            </a>
            <br />
            <a className={style.subtitle_link} href="#cancellation-policy ">
              18. Cancellation Policy
            </a>
            <br />
            <br />
            <h3 className={style.title} id="scope-of-this-agreement">
              1. Scope of this Agreement
            </h3>
            <p className={style.text}>
              Scope of the Agreement is the use of the corresponding specifically agreed service, as
              outlined in the respective specific service sections, provided by us to the User for a
              fee or at no cost.
              <br />
              <br />
              These T&C govern any contractual relationships between us and the User. This is true
              regardless of whether the making of declarations, the logging in, the registration,
              the conclusion of the Agreement, the provision of Services, or the receipt of Services
              occurs in Ireland or elsewhere.
            </p>
            <h3 className={style.title} id="conclusion-of-the-agreement">
              2. Conclusion of the Agreement
            </h3>
            <p className={style.text}>
              The presentation of Services on{" "}
              <Link href={"/"} className={style.innerLink} data-sentry-element="Link" data-sentry-source-file="index.tsx">
                www.qrcodecreator.com
              </Link>
              does not constitute a legally binding offer by us, but rather a non-binding invitation
              to the User to submit an offer.
              <br />
              <br />
              Please carefully review these terms to ensure your full comprehension of each
              provision. By registering an account and clicking on "Sign Up," "Sign Up with Google,"
              "Sign Up with Facebook," or any similar acceptance method, or by accessing or using
              our Site, you submit an offer and indicate your agreement to these terms
              electronically. Upon the User's submission of a binding offer for registration, we
              immediately send an email to the User's provided email address. Our such email serves
              as receipt confirmation and constitutes acceptance of the offer unless explicitly
              stated otherwise. You confirm that you have read, comprehended, and consent to be
              legally obligated by these terms. We retain all rights that are not explicitly granted
              under these terms. If you do not agree to all the terms and conditions of this
              Agreement, then you may not access the Site or use any Services. If these Terms of
              Service are considered an offer, acceptance is expressly limited to these Terms of
              Service.
              <br />
              <br />
              The User is responsible for ensuring that the e-mail address provided is accurate and
              that e-mails sent by QR Code Creator will be received and not blocked or otherwise.
            </p>
            <h3 className={style.title} id="services">
              3. Services
            </h3>
            <h4 className={style.subtitle}>3.1 General</h4>
            <p className={style.text}>
              Our Services may be used for both personal and business purposes unless it is
              expressly stated within each service that only private or commercial use is permitted.
              Our objective is to provide Users with uninterrupted service availability and
              error-free functionality. Nevertheless, we may limit or completely shut down Services
              and/or systems during off-peak hours for maintenance or performance optimization. We
              reserve the right to terminate all Services with prior written notice of at least one
              (1) month to the end of the contractual term unless otherwise specified herein.
            </p>
            <h4 className={style.subtitle}>3.2 Account / Profile</h4>
            <p className={style.text}>
              You may create and use an account as a registered User in accordance with the
              Acceptable Use Guidelines as determined in section 16 hereof. The use of pseudonyms,
              nicknames, or professional names in place of given names and surnames, as well as
              multiple registrations, is prohibited unless we grant a written consent in advance.{" "}
              <br />
              <br />
              The User agrees to provide complete and accurate information upon registration and
              throughout the duration of the relationship, as well as to keep this information up to
              always date.
              <br /> <br />
              The User must not reveal any account information, including the password, to any third
              party. The User is solely accountable for maintaining the account's secrecy and
              security, as well as for all activities that occur through or in connection with it.
              In the event of any suspected security breach or account misuse, the User shall
              immediately notify us in writing.
              <br />
              <br />
              We are not liable for any losses or damages resulting from unauthorized account use.
              This explicitly accounts for information stored within the account as well as any
              potentially damaging misuse of a compromised account, such as the exchange of links to
              specific codes or similar activities.
            </p>
            <h4 className={style.subtitle}>
              3.3 QR Code, vCards, and (mobile) website tools and advisory services
            </h4>
            <p className={style.text}>
              We provide Services in the areas of creation, design, management, optimization,
              scanning, and analysis of QR Codes, vCards, and (mobile) websites, as well as the
              tools and advisory services associated with these areas.
              <br />
              <br />
              Our specific contractual services are derived from the respective specific
              descriptions within each service section. The same applies to the scope of Services,
              the duration of Services, the User's payment obligations, and other specific service
              conditions.
              <br />
              <br />
              Our Services rely heavily on the availability of third parties, such as the global
              internet and mobile communications infrastructure, data centers, telephone lines,
              mobile communications systems, domains, applications, and so on. The User is aware
              that these factors are beyond our control and responsibility and acknowledges that, as
              a result, Services may be wholly or partially (e.g., single services or only for
              specific Users), permanently or temporarily, discontinued, restricted, blocked, or
              modified, as required.
              <br /> <br />
              We utilize programs that enable inferences about user usage and behavior. This
              information improves security, optimizes Services, and is handled confidentially in
              accordance with the data protection provisions and regulations of our Privacy Policy.
              <br /> <br />
              Services enable the User to upload, submit, store, send, receive, or share the content
              of their choosing. There is no requirement to provide any content. If the User chooses
              to upload or share content, they are responsible for ensuring that they have the
              necessary rights to do so and that the content is lawful. We reserve the right to
              modify these guidelines at any time.
            </p>
            <h4 className={style.subtitle}>3.4 Tools/features undergoing testing</h4>
            <p className={style.text}>
              We may release tools, features, or the like (henceforth "Test Services") that are
              still in the testing or evaluation phase. These Test Services will be clearly labeled
              as such, using terms such as "test," "evaluation," "alpha," "beta," and "preview,"
              among others. The Test Services might not be as trustworthy as other Services. We make
              the Test Services available to Users to gather feedback on the user-friendliness and
              general functionality of the Services and to enhance them. User-friendliness can be
              assessed through statistical assessments, in all cases without individual human
              verification. Test Services are confidential until their official launch.
            </p>
            <h4 className={style.subtitle}>3.5 Other Services</h4>
            <p className={style.text}>
              We are continually developing new services that could be added to the services
              sections. The User may be notified of such services, for instance via a pop-up within
              the User's account. To obtain these services, the terms outlined in Section 2 of this
              Agreement regarding the Conclusion of an Agreement apply. To the extent required by
              law, the User's consent will be obtained in this regard.
            </p>
            <h4 className={style.subtitle}>3.6 Refusal of Guarantee</h4>
            <p className={style.text}>
              We make every effort to deliver Services, but we cannot guarantee certain aspects. To
              the maximum extent permitted by law, we make no express or implied warranties
              regarding the Services. We disclaim any warranty claims of merchantability, fitness
              for a particular purpose, and non-infringement, and the Services are provided "as is."
              This paragraph's disclaimers may not apply to you, as they are prohibited in some
              jurisdictions.
            </p>
            <h3 className={style.title} id="age-requirement">
              4. Age Requirement
            </h3>
            <p className={style.text}>
              If a User is a natural person, our Services are primarily geared toward adults of
              legal age. If a User is under the minimum age to obtain Services, the User must have
              parental consent and the parent or legal guardian must have read these T&C.
            </p>
            <h3 className={style.title} id="remuneration">
              5. Remuneration
            </h3>
            <p className={style.text}>
              5.1 All prices do not include any applicable statutory value-added tax ("VAT"), sales
              tax or similar taxes.
              <br /> <br />
              5.2 Unless our corresponding Service is free of cost, compensations and fees to be
              paid by the User and valid at the time of the Agreement's conclusion are presented in
              the respective service sections, along with all related price components and
              calculation basis, payment processes, and payment terms. We will provide the User with
              the corresponding contractual invoice by mail, e-mail, or for download within the
              User's account upon or after acceptance of the Agreement.
              <br /> <br />
              5.3 Fees are due after the conclusion of the Agreement. The User will be considered as
              being in default if the due date of payment, which is determined by the calendar, has
              been missed. If this happens, the User shall pay yearly default interest fee at a rate
              of 5 percent of the missed payment amount above the prime rate. The User’s obligation
              to pay interest on arrears does not prevent us from claiming further damages caused by
              default.
              <br /> <br />
              5.4 If the User fails to comply with the corresponding contractual payment
              obligations, we may set an appropriate grace period with a termination threat, after
              which we may terminate the Agreement and delete all data immediately, without implying
              a separate contractual obligation to delete data. The termination clauses in Section
              13 of these T&C remain unchanged.
              <br /> <br />
              5.5 We are not obligated to provide or unlock Services prior to receiving due payment.
              <br /> <br /> 5.6 Non-use of Services does not release the User from payment
              obligations.
              <br /> <br />
              5.7 Objections to the billing of Services provided by us must be made online or in
              writing to our office listed on the respective invoice. <br /> <br />
              5.8 Offsetting against counterclaims of the User or withholding payments due to such
              claims is only permitted if the counterclaims are undisputed, legally established, or
              result from the same order under which the relevant delivery was made.
            </p>
            <h3 className={style.title} id="user-rights-and-obligations">
              6. User Rights and Obligations
            </h3>
            <p className={style.text}>
              The User utilizes Services in accordance with all applicable statutory and legal
              provisions. This means specifically, but not exclusively the following:
              <br /> <br />
              <span className={style.list_item}>
                The User does not use any illegal content or link to illegal content that violates
                laws, official regulations, or the rights and freedoms of third parties when
                utilizing Services and does not place such content or link on Services, such as
                storage space. We reserve the right, without prior notice, to delete, block, or
                restrict Services, corresponding content, links, or codes in the event of such
                violations, illegal content, or suspected misuse.
              </span>
              <span className={style.list_item}>
                The User prevents unauthorized access to his/her account by third parties by taking
                necessary precautions.
              </span>
              <span className={style.list_item}>
                User neither transfers Services nor rights hereunder to third parties nor makes them
                available for use by third parties.
              </span>
              <span className={style.list_item}>
                Before entering data and information into the Site's storage space, the User
                inspects them for viruses and other potentially harmful components.
              </span>
              <span className={style.list_item}>
                The information that the User stores on the Site-provided storage space may be
                protected by copyright and data protection laws. The User henceforth grants us the
                right to store, reproduce, and transfer the content for the User's purposes, as well
                as reproduce the content for data backup purposes, in accordance with the Upload
                Content License.
              </span>
              <span className={style.list_item}>
                The User is prohibited from taking any actions that could compromise the
                functionality of the Services. This includes, but is not limited to, the use of
                viruses, malicious software, or software that automatically generates user requests
                via the Internet or acts otherwise to our detriment. The User will not alter,
                manipulate, overwrite, copy, or distribute our or our service providers' website
                areas or the website areas of other users.
              </span>
              <span className={style.list_item}>
                The User is responsible for the technical devices, communication channels, hardware,
                and software used in conjunction with Services. This also applies to their
                suitability and safety.
              </span>
            </p>
            <h3 className={style.title} id="license-to-qrcodecreator">
              7. License to Us
            </h3>
            <p className={style.text}>
              7.1 If the User is a business entity, the User grants us a non-exclusive,
              non-transferable, worldwide, royalty-free, limited license to use the User's name,
              trademarks, and logos to reference the User as our customer on the Site and in the
              Site’s marketing materials. The User warrants to us that they have the right, title,
              and/or authority to grant us such a license. If you previously rejected this clause,
              it would not apply to you. If you previously agreed to a version of these T&C that
              permitted you to opt-out of this provision, your previous decision to opt-out or not
              opt-out remains binding. If you have separately agreed to specific details with us at
              an earlier time that differs from this clause, the individual agreement takes
              precedence for you.
              <br /> <br />
              7.2 To opt-out of this clause and thereby refuse to grant us such a license, please
              send an email to{" "}
              <a href="mailto:support@qrcodecreator.com" className={style.innerLink}>
                support@qrcodecreator.com
              </a>
              with your customer number and company name.
              <br /> <br />
              7.3 For additional licensing information, consult the Upload Content License.
            </p>
            <h3 className={style.title} id="revocation">
              8. Revocation
            </h3>
            <p className={style.text}>
              The User has a right to withdraw from the Agreement by revoking/canceling his/her
              subscription as described herein. For further details, please refer to the
              Cancellation policy in the Article 18.
            </p>
            <h3 className={style.title} id="liability">
              9. Liability
            </h3>
            <p className={style.text}>
              9.1 We are liable to the extent of any guarantee assumed by us and in the event of
              gross negligence only.
              <br /> <br />
              9.2 In the occasion of a slightly negligent breach of an obligation that is crucial to
              the achievement of the purpose of the Agreement (cardinal obligation), our liability
              is limited to the amount of damage that is foreseeable and typical given the nature of
              the respective contractual relationship. <br /> <br />
              9.3 In no case shall we, our directors, officers, employees, affiliates, agents,
              contractors, interns, suppliers, service providers, or licensors be liable for (i) any
              injury, loss, claim, or any direct, indirect, incidental, punitive, special, or
              consequential damages of any kind, including, without limitation lost profits, lost
              revenue, lost savings, loss of data, replacement costs, or any similar damages,
              whether based in contract or otherwise, arising from your use of any of the Services
              or any products procured using the Services, or for (ii) any other claim related in
              any way to your use of the Services or any product procured using the Service,
              including, but not limited to, any errors or omissions in any content, or any loss or
              damage of any kind incurred as a result of the use of the Services or any content (or
              product) posted, transmitted, or otherwise made available via the Services, even if
              advised of their possibility.
              <br /> <br />
              The foregoing limitations of liability shall apply to the fullest extent permitted by
              law in the applicable jurisdiction. Because some states or jurisdictions do not allow
              the exclusion or the limitation of liability for consequential or incidental damages,
              in such states or jurisdictions, our liability shall be limited to the maximum extent
              permitted by law.
              <br />
              <br />
              Except as expressly provided in the Agreement, neither we nor our subcontractors make
              any representations or warranties, express or implied, statutory or otherwise,
              regarding any matter, including the merchantability, suitability, or fitness for a
              particular use or purpose, non-infringement, or results to be derived from the use of
              or integration with any Services and products provided under the Agreement, or that
              the operation of any products or Services will be uninterrupted or error-free. The
              User agrees not to obtain subscriptions for any service based on the delivery of
              future functionality, public comments or advertising by us, or product road maps.
              <br /> <br />
            </p>
            <h3 className={style.title} id="indemnity">
              10. Indemnity
            </h3>
            <p className={style.text}>
              The User agrees to indemnify, defend and hold us and our shareholders, subsidiaries,
              affiliates, partners, officers, directors, agents, contractors, licensors, service
              providers, subcontractors, suppliers, interns, and employees, harmless from any claim
              or demand, including liabilities, losses, costs, damages, reasonable attorneys’ fees,
              made by any third party due to or arising out of your breach of the T&C or the
              documents it incorporates by reference or violation of any law or the rights of a
              third-party.
              <br />
              <br />
              The User agrees to indemnify, defend and hold us and our shareholders, subsidiaries,
              affiliates, partners, officers, directors, agents, contractors, licensors, service
              providers, subcontractors, suppliers, interns, and employees, harmless from any and
              all claims arising out of or relating to (i) the User's gross negligence or willful
              misconduct in the performance of its/his/her duties hereunder, or (ii) the User's any
              breach of any material representation or warranty explicitly made by the User
              hereunder.
            </p>
            <h3 className={style.title} id="non-disclosure">
              11. Non-disclosure
            </h3>
            <p className={style.text}>
              11.1 "Confidential Information" refers to all information and documents of the
              respective other party that is marked as confidential or that are to be considered
              confidential based on the circumstances, including information on operational
              processes, business relations, and know-how. <br /> <br />
              11.2 The parties agree to keep confidential any Confidential Information. <br />{" "}
              <br />
              11.3 Information is not deemed confidential if (i) it was legally known to the
              recipient upon disclosure of such information by the disclosing party, or (ii) it is
              broadly known and publicly available, or (iii) it is disclosed by the disclosing party
              to third parties without restrictions, (iv) it is acquired by the recipient from a
              third party which was not, to the recipient’s knowledge, under an obligation to the
              disclosing party not to disclose such information, or (v) it represents the ideas,
              concepts, methods, processes, systems, ways and etc. developed by the recipient
              independently and without the use of the Confidential Information received from the
              disclosing party.
              <br /> <br />
              11.4 The Parties shall grant access to confidential information to those who are bound
              by professional secrecy or who have been previously subject to confidentiality
              obligations equivalent to those of this Agreement.
            </p>
            <h3 className={style.title} id="intellectual-property-rights">
              12. Intellectual Property Rights
            </h3>
            <p className={style.text}>
              12.1 We ensure that the User's contractual use of the Services does not violate any
              third-party rights. We offer the User, in the event of title defects, the opportunity
              to use the Services or an equivalent at its sole discretion. If there are indications
              of possible violations of the rights of third parties, we will evaluate the
              plausibility of these indications and, if reasonable suspicion of an infringement
              exists, will take appropriate action.
              <br /> <br />
              12.2 Except with respect to your User Content and other Registered Users’ Content, you
              agree that, as between you and us, the ownership of all intellectual property rights
              (whether by license, ownership or otherwise) with respect to the Site
              (www.qrcodecreator.com) and its relevant software shall remain in the hands of
              Convertizing LTD.
              <br />
              <br />
              The Services as a whole are copyrighted as a collective work, and individual works or
              content appearing on or accessible through the Site are likewise subject to copyright
              protection domestically and internationally. Likewise, all data files, program files,
              software, code, proprietary methods, systems, and other materials that are made
              available to download from or used to provide the Service (“Materials”) may not be
              copied, modified, reproduced, republished, posted, transmitted, sold, offered for
              sale, or redistributed in any way without our prior written permission and the prior
              written permission of our applicable licensors. The Materials are protected by
              copyrights, patents, trade secrets, or other proprietary rights. You must abide by all
              copyright notices, information, or restrictions contained in or attached to any of our
              Materials. Nothing in this Agreement grants you any right to receive delivery of a
              copy of our Materials or to obtain access to our Materials except as generally and
              ordinarily permitted through the Service according to these T&C.
              <br />
              <br />
              12.3 <span className={style.subtitleBold}>Trademarks:</span> Certain product and
              company names, logos, distinctive features, source identifiers, and other materials
              displayed on the Site or in the Services, including its “look and feel”, constitute
              trademarks, trade names, service marks, or logos of Convertizing LTD (“Trademarks”).
              You are not authorized to use any such Trademarks. The Trademarks may not be copied,
              imitated, or used, in whole or in part, without our prior written consent. You will
              not remove, alter, or obscure any copyright, trademark, service mark, or other
              proprietary rights notices incorporated in or accompanying the Services. Other
              services and company names mentioned on this Site may be the trademarks of their
              respective owners.
              <br />
              <br />
              12.4 <span className={style.subtitleBold}>Software:</span> Any software, as well any
              files or images generated by such software, code, and data accompanying such software
              (the “Software”), used or accessible through this Site is the copyrighted work of
              Convertizing LTD. You are licensed to use the Software on a non-exclusive basis unless
              it is provided for elsewhere. Except as permitted by law, you may not use the Software
              for any other purpose or attempt to decipher, decompile, disassemble, or reverse
              engineer any of the Software comprising or in any way making up a part of the Site.
            </p>
            <h3 className={style.title} id="termination-duration">
              13. Termination/Duration
            </h3>
            <p className={style.text}>
              13.1 Unless otherwise agreed, this Agreement is concluded for an indefinite duration
              based on the periods specified in the specific service sections. The duration of
              Services will be automatically extended for the same duration at the same price. The
              relationship commences with the User's registration and login and may be terminated by
              either party with the deletion of the account in accordance with this Agreement. If
              the Agreement is terminated by Us during the provision of the agreed Services, We will
              notify you with prior written notice at least one (1) month to the end of the
              contractual term. If the Agreement is terminated by You during the provision of the
              agreed Services, the Cancellation policy in the Section 18 will apply.
              <br /> <br />
              13.2 In the event that the User's account is deleted during an agreed-upon contractual
              period, the deletion has no bearing on any potential payment obligations unless
              otherwise specifically determined herein.
              <br /> <br />
              13.3 The right of each party to terminate the Agreement for cause without notice
              (extraordinary termination) is unaffected. We may terminate the Agreement and delete
              the User’s account without prior notice and without any payment obligation, if the
              User infringes contractual or legal obligations, affects the safety of our systems,
              other users, or third parties, fails to make payments despite a reminder and the
              setting of a relevant grace period.
              <br /> <br />
              13.4 Termination upon Expiry of Trial Period <br /> The new User may choose a{" "}
              {FREE_TRIAL_DAYS}-day free trial period after registration (the “Trial”). After the
              Trial expires, the User’s account will remain accessible, and the User’s data will
              become temporarily unavailable until s/he switches to a new subscription plan. Once
              the Trial expires, Static QR codes will continue to function, while Dynamic QR codes
              generated during the Trial will be temporarily deactivated and lead to the service
              page until the User subscribes to a new plan. If the User does not subscribe to a new
              subscription plan within a 90-day period after the Trial period expires, We retain the
              right to terminate the Agreement and delete the User's account at our sole discretion.
            </p>
            <h3 className={style.title} id="obligatory-arbitration-provisions">
              14. Obligatory Arbitration Provisions (applies only to US citizens)
            </h3>
            <p className={style.text}>
              14.1 All disputes arising from or relating to this agreement shall be finally resolved
              in accordance with the Arbitration Rules of the International Court of Arbitration.{" "}
              <br /> <br />
              14.2 The Court of Arbitration shall be composed of one arbitrator who shall be a
              member of the Bar of Ireland and is fluent in English. <br /> <br />
              14.3 The place of arbitration shall be the county in the United States where the User
              resides or works, or any other location agreed upon by the parties. <br /> <br />
              14.4 The arbitration is conducted in English. <br /> <br />
              14.5 The Court of Arbitration shall apply Irish law in accordance with this Agreement.
              The Court of Arbitration shall apply the civil procedure rules of Ireland in terms of
              procedure, particularly with regard to the taking of evidence. <br /> <br />
              14.6 Dissenting opinions shall not be allowed. <br /> <br />
              14.7 The User may only resolve disputes with us on an individual basis and may not
              bring a claim in a class, consolidated, or representative action as a plaintiff or
              class member. Class arbitrations, class actions, private attorney general actions, and
              consolidation with other arbitrations are not permitted. If this particular paragraph
              is deemed unenforceable, the entire "Obligatory Arbitration Provisions" section will
              be null and void.
            </p>
            <h3 className={style.title} id="final-regulations">
              15. Final Regulations
            </h3>
            <p className={style.text}>
              15.1 The invalidity of one or more provisions of the Agreement shall not affect the
              validity of the remaining provisions. The parties to the Agreement shall make every
              effort to replace an invalid provision with a valid provision that comes as close as
              possible to the economic intent of the invalid provision. <br /> <br />
              15.2 Our failure to enforce a provision does not waive its right to do so in the
              future.
              <br /> <br />
              15.3 The User may only assign claims against us to third parties with our prior
              written consent.
              <br /> <br /> 15.4 The terms of this Agreement are exclusive. Deviating, inconsistent,
              or additional General Terms and Conditions of Users with legal capacity who, when
              concluding a legal transaction, act in the exercise of their commercial or independent
              professional activity shall only become part of the Agreement if and to the extent
              that we expressly agree to their validity. This consent requirement applies
              regardless, for example, even if we provide services to the User while aware of the
              User's General Terms and Conditions.
              <br /> <br />
              15.5 Our registered office is the exclusive place of jurisdiction for disputes arising
              out of this Agreement. Any dispute, controversy or claim arising out of or in
              connection with this Agreement, including any question regarding the construction,
              breach, interpretation, validity, performance, or termination thereof, and the
              negotiations relating to the Services shall be referred to and finally resolved by the
              courts of the Republic of Ireland.
              <br /> <br />
              15.6 This Agreement is governed by the Irish law.
              <br /> <br />
              <i>Changes to the Terms of Service</i>
              <br />
              Any new features or tools which are added to the current platform shall also be
              subject to the Terms of Service. You can review the most current version of the Terms
              of Service at any time on this page. We reserve the right, at our sole discretion, to
              update, change or replace any part of these Terms of Service; We will notify you via
              email of such updates and changes, unless they are technical or otherwise
              inconsequential to the User experience. In case of significant changes that would have
              a negative impact on your use of our Services or if we discontinue our Services, we
              will notify you in advance, unless there are exceptional circumstances, such as
              preventing abuse or changes required by law. Your continued use of or access to our
              Site or the Service following the notification of any changes to these Terms of
              Service constitutes acceptance of those changes.
              <br /> <br />
              <i>Changes to the Site</i>
              <br />
              We may terminate, change, suspend or discontinue any aspect of this Site due to
              reasons including but not limited to those listed below:
              <br />
              <span className={style.list_item}>
                changing the availability of any features at any time;
              </span>
              <span className={style.list_item}>
                changing any fees or charges for use of the Site, including instituting new or
                increased fees or charges for the use of the Site or any features thereof;
              </span>
              <span className={style.list_item}>
                removing, adding, modifying, or otherwise changing any content on or from this Site;
              </span>
              <span className={style.list_item}>
                imposing limits on certain features or services or restricting your access to parts
                or the entire Site for any reason whatsoever.
              </span>
              We reserve the right but not the duty, to correct any errors or omissions in any
              portion of this Site at any time without notice.
            </p>
            <h3 className={style.title} id="acceptable-use-guidelines">
              16. Acceptable Use Guidelines
            </h3>
            <p className={style.text}>
              16.1 We view QR codes as one of the most significant technological enablers at the
              interface between the real and digital worlds. We feel obligated to ensure that
              technology is used in a way that is beneficial to people and our society.
              <br /> <br />
              16.2 Therefore, we have established some general rules and guidelines for how our
              solutions and services are NOT intended to be used, which you accept by using our
              Services. This includes encouraging others to act in a similar manner.
              <br /> <br />
              16.3 These rules include, but are not limited to the following:
              <br /> <br />
              <span className={style.list_item}>
                scanning or testing our systems and/or network for vulnerabilities in any way;
              </span>
              <span className={style.list_item}>
                any breach of authentication or security protocols;
              </span>
              <span className={style.list_item}>
                accessing, modifying, or illegally utilizing shared areas that require authorization
                or non-public areas of service;
              </span>
              <span className={style.list_item}>
                interfering with or disrupting the network, host, or user of the service (by
                overloading, spamming, or other similar activities) or failing to obey any
                requirements, procedures, policies, or regulations of platforms, domains, and
                networks that are connected to our website;
              </span>
              <span className={style.list_item}>
                misusing or creating accounts for any purpose other than the intended use of our
                publicly supported interfaces, such as mass-creating accounts;
              </span>
              <span className={style.list_item}>
                sending unrequested communication, advertisements, or spam to users or third
                parties, or sending malware, viruses, or other forms of harmful software to users or
                third parties;
              </span>
              <span className={style.list_item}>
                sending promotions or advertisements for products or services other than your own
                without permission;
              </span>
              <span className={style.list_item}>
                manipulating identifiers by forging email headers and/or sending deceptive or
                altered information to conceal the origin of any user-generated content transmitted
                through our websites, including "phishing" and "spoofing"", “hacking”, or other
                attempts;
              </span>
              <span className={style.list_item}>
                impersonating a person or entity or otherwise misrepresenting or faking your
                affiliation with a person or entity;
              </span>
              <span className={style.list_item}>
                collecting or storing any data or personally identifiable information of other
                users;
              </span>
              <span className={style.list_item}>
                utilizing our solutions, features, or goodwill beyond "normal" usage, such as
                "unlimited" scans;
              </span>
              <span className={style.list_item}>
                uploading, publishing, distributing, or promoting any content that is illegal under
                local, state, national, or international laws and regulations, or that violates
                others' privacy or rights; This includes, but is not limited to, contents that
                infringe on intellectual property rights, contain viruses, are objectionable legally
                or ethically, or breach the requirements, procedures, policies, or regulations of
                the networks, platforms, or domains connected to our website. This prohibition also
                applies to any contents displayed on a third-party network, platform, domain,
                website directed when using our QR Code. In all cases the User will be solely liable
                under the local, state, national, or international laws and regulations, and
                “indemnity” provisions (Section 10) and any relevant provisions of these Terms and
                Conditions will apply in any of such cases;
              </span>
              <span className={style.list_item}>
                uploading, publishing, distributing or promoting any content that (i) is related to
                hatred or prejudice against any individual or group based on their race, ethnic
                background, religion, sex, gender identity, national identity, sexual orientation,
                disability, or impairment, as well as any content promoting third parties with such
                views; and (ii) exploits children, disseminates false information, whether it be
                medical or not, shares sexually explicit or intimate content without permission,
                threatens or encourages violence, glamorizes or encourages self-harm or puts one's
                safety in danger, contains violence or supports terrorist activity and propaganda,
                or is otherwise illegal. This prohibition also applies to any contents displayed on
                a third-party network, platform, domain, website directed when using our QR Code. In
                all cases the User will be solely liable under the local, state, national, or
                international laws and regulations, and “indemnity” provisions (Section 10) and any
                relevant provisions of these Terms and Conditions will apply in any of such cases;
              </span>
              <span className={style.list_item}>
                harassing, threatening, defaming, abusing, or otherwise violating the legal rights
                of our personnel or other users, including but not limited to bullying, harassing,
                or attacking individuals or groups;
              </span>
              <span className={style.list_item}>
                carrying out illicit activities, such as the trading of forbidden products and/or
                services;
              </span>
              <span className={style.list_item}>
                contravening any applicable local, state, national, or international laws, as well
                as others' privacy or rights.
              </span>
              <span className={style.list_item}>
                We reserve the right to suspend or terminate any account or restrict or delete any
                content that we deem to have a detrimental effect on the user experience or the
                safety of the public at large, as prohibited by our Acceptable Use Guidelines.
              </span>
            </p>
            <h3 className={style.title} id="upload-content-license">
              17. Upload Content License
            </h3>
            <h4 className={style.subtitle}>17.1 License</h4>
            <p className={style.text}>
              The content that you provide remains yours. Therefore, you retain any intellectual
              property rights that you have in your content, including but not limited to the
              intellectual property right in the creative content you produce by writing reviews or
              the right to share someone else's creative content if they have given you permission
              to do so. If your intellectual property rights restrict our use of your content, we
              need your permission. This license grants us permission in this regard. <br /> <br />
              This license is worldwide, non-exclusive, assignable, sublicensable, transferable, and
              royalty-free. This means that it is applicable worldwide, there are no restrictions on
              the licensing of your content to others, and there are no fees associated with this
              license. <br /> <br />
              Your content is covered by the license so long as it is protected by intellectual
              property rights. Your data security rights are unaffected.
              <br />
              <br />
              The following forms of content are excluded from coverage under this license:
              <span className={style.list_item}>
                Publicly accessible information, such as corrections to the address of a local
                business, any information that is considered common knowledge and can be freely used
                by anyone without the need for a license.
              </span>
              <span className={style.list_item}>
                Your comments (e.g., suggestions to improve our Services).
              </span>
            </p>
            <h4 className={style.subtitle}>17.2 Purpose</h4>
            <p className={style.text}>
              This license's scope is limited to the operation of Services, allowing them to create
              new features and functions and operate as intended by their designers. This includes
              analyzing your content using automated systems and algorithms. As the content is
              transmitted, received, stored, and utilized, it is analyzed:
              <span className={style.list_item}>
                to scan for illegal content, spam, or malware;
              </span>
              <span className={style.list_item}>
                to recognize data patterns used in functionalities such as storage optimization;
              </span>
              <span className={style.list_item}>
                to personalize our Services for you and to provide the Services such as usage
                recommendations or customized designs, content, and advertisements in the case of a
                free generator.
              </span>
            </p>
            <h4 className={style.subtitle}>17.3 Rights</h4>
            <p className={style.text}>
              Within the scope of the above-mentioned limited purposes, the following rights are
              granted to us via this license: <br />
              <span className={style.list_item}>
                utilize your content solely for technical purposes, such as the storage of your
                content on our systems to make it accessible from anywhere or to ensure the
                compatibility of your content with our Services by reformatting your content;
              </span>
              <span className={style.list_item}>
                ensuring the public availability of your content if you have made it visible to
                others;
              </span>
              <span className={style.list_item}>
                sublicense these rights to other users to ensure that the Services function as
                intended, such as enabling you to share photos with other users;
              </span>
              <span className={style.list_item}>
                sublicense these rights to our contractors under agreements that are consistent with
                these terms and doing so within the scope of the limited purposes described in the
                section titled "Purpose".
              </span>
            </p>
            <h4 className={style.subtitle}>17.4 Duration</h4>
            <p className={style.text}>
              This license is valid for the period that your content is protected by intellectual
              property rights. This does not apply if you remove your content from our Services
              before the expiration date.
              <br /> <br />
              The removal of any of your content from our Services that is covered by this license
              will cause our systems to stop making this content publicly accessible within a
              reasonable timeframe. There are the following exceptions:
              <br />
              <span className={style.list_item}>
                you have shared your content with others via a static QR code that links to a
                third-party website before removing it;
              </span>
              <span className={style.list_item}>
                it is possible that search engines and so-called web archives will continue to find
                and display your content as part of their search results if you make your content
                accessible through the services of other companies.
              </span>
            </p>
            <h3 className={style.title} id="cancellation-policy">
              18. Cancellation policy
            </h3>
            <h4 className={style.subtitle}>18.1 The right to cancel the subscription</h4>
            <p className={style.text}>
              You may cancel your subscription at any time without providing a reason by logging
              into your account or contacting us using the contact information and form provided
              below. Your cancellation will take effect at the end of your current paid term.
              <br />
              <br />
              To exercise the right of cancellation, the User must inform Us{" "}
              <a href="mailto:support@qrcodecreator.com" className={style.innerLink}>
                (support@qrcodecreator.com)
              </a>
              of his/her decision to cancel his/her subscription by a clear statement (e.g., a
              letter sent via post, fax, or email; see the model cancelation form for this purpose).
              The User may also electronically complete and submit the model cancellation form or
              another clear declaration on his/her account on the Site.
              <br /> <br />
              All purchases of the Services are final, and no refund shall be provided due to
              cancellation except as specifically noted in these Terms.
            </p>
            <h4 className={style.subtitle}>18.2 Refund policy for EU residents only</h4>
            <p className={style.text}>
              If the User is a customer residing in the EU, when buying digital content, the User
              has a right to withdraw from the Agreement within the period of 14 days from the
              purchase date, but only up until the moment the actual downloading process of the
              digital content begins.
              <br />
              <br />
              The right to withdraw from the Agreement for the supply of such digital content will
              not apply if the User has expressly stated that s/he wishes to receive or download the
              digital content within the withdrawal period and has expressly waived the right of
              withdrawal. When downloading the content created on the Site, during the 14-day
              withdrawal period, the User will be asked to agree that s/he will lose his/her right
              of withdrawal and s/he will not be eligible for any refund.
              <br />
              <br />
              Within 14 days of the User’s declaration that s/he wants to invoke this guarantee, the
              amount paid by you shall be refunded.
            </p>
            <h4 className={style.subtitle}>18.3 Sample cancellation form</h4>
            <p className={style.text}>
              If you wish to cancel the agreement, please complete, and return this form.
              <br /> <br />
              To: <br />
              QR Code Creator,
              <br />
              407 Cubes 1, <br />
              Beacon South Quarter, Sandyford,
              <br />
              Dublin 18, <br />
              Ireland
              <br /> <br />
              Email:{" "}
              <a href="mailto:support@qrcodecreator.com" className={style.innerLink}>
                support@qrcodecreator.com
              </a>{" "}
              <br /> <br />
              I/we (*) hereby withdraw from the contract for the purchase of the following items
              (*)/provision of the following service (*).
              <br />
              Purchased on (*) and received on (*) <br />
              Name of the client (s) <br />
              Address of the client (s)
              <br />
              Signature(s) of the customer(s) (only in case of paper communication)
              <br />
              Date\s <br />
              (*) Delete where irrelevant
            </p>
            <p className={style.text}>
              Note regarding the early expiration of the revocation
              <br />
              <br />
              We would like to draw your attention to the fact that in the case of contracts for the
              delivery of data that is not on a physical medium and is created and made accessible
              in digital form (digital content), your right of revocation will expire prematurely if
              you have expressly consented to us commencing performance of the contract prior to the
              expiration of the revocation period and have confirmed your knowledge that by giving
              your consent you will lose your right of revocation upon commencement of performance
              of the contract.
            </p>
            <h4 className={style.subtitle}>
              18.4 Deletion of the User’s account upon cancellation
            </h4>
            <p className={style.text}>
              After the paid subscription plan is cancelled, the User’s account will remain
              accessible until the conclusion of your current paid subscription term. After the
              current paid subscription term, the User’s data will become temporarily unavailable
              until s/he switches to a new paid subscription plan. If the User does not subscribe to
              a new paid subscription plan within a 90-day period after his/her current paid
              subscription plan expires, We retain the right to terminate the Agreement and delete
              the User's account at our sole discretion.
            </p>
          </div>
        </div>
      </div>
    </Layout>;
};
export default Terms;